import React from "react";
import JalRoLayout from "../components/JalRoLayout";
import { CareersSection, ContactSection, PageHero } from "../components/JalRoSections";

const CareersPage = () => (
  <JalRoLayout>
    <PageHero
      title="Careers at Jal RO System"
      text="Join our RO service team for technician, commercial RO and customer support roles."
      image="/assets/img/jal-ro/service-tech.png"
    />
    <CareersSection />
    <ContactSection />
  </JalRoLayout>
);

export default CareersPage;
